window.CC = window.CC || {};
window.CC.utils = window.CC.utils || {};

window.CC.utils.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
window.CC.utils.getCookie = function getCookie(cname) {
  var name = cname + "="; var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) { var c = ca[i]; while (c.charAt(0) == ' ') { c = c.substring(1); } if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); } }
  return "";
}
function queryParamHashMap() {
  var hash = {};
  document.location.search.replace('?', '')
  .split('&').forEach(function (o){
    var s = o.split('='); hash[s[0]]=s[1];
  });
  return hash;
}
window.CC.utils.featureTestByQueryParam = function(name) {
  var param = queryParamHashMap()[name];
  if(param === '1') {
    CC.utils.setCookie(name, 1, 1)
  } else if (param === '0') {
    CC.utils.setCookie(name, 0, -1);
  }
}
window.CC.utils.shouldRunTest = function(name) {
  return !!CC.utils.getCookie(name);
}
window.CC.utils.coordinates = {
  getAddressFromLatLng: function (lat, lng, success) {
    new google.maps.Geocoder().geocode({ location: { lat: lat, lng: lng }}, function (results, status) {
      if (status === 'OK' && results && results[0]) {
        success(results[0].formatted_address);
      }
    });
  },
  convertTo: {
    string: function (coordInt, axis) {
      function roundToFour(num) {
        return Number(Math.round(num + 'e+4') + 'e-4');
      }
      var roundedCoord = roundToFour(coordInt);
      var absCoord = Math.abs(roundedCoord).toPrecision(6);
      var direction;

      if(axis === 'lat') {
        direction = roundedCoord > 0 ? 'N' : 'S';
      } else if (axis === 'lng') {
        direction = roundedCoord > 0 ? 'E' : 'W';
      }

      return absCoord + '° ' + direction;
    },
    number: function () {

    }
  }
}
window.CC.loaded = false;
window.CC.modal = {
  $modalEle: undefined,
  build: function () {
    window.CC.modal.$modalEle = $('<div class="cc-mobile-modal"><div class="cc-mobile-controls"><span class="cc-modal-close">CLOSE</span></div><div class="cc-mobile-modal--inner"></div></div>');
    $(document.body).append(window.CC.modal.$modalEle);
    window.CC.modal.$modalEle.find('.cc-modal-close').on('click', function () {
      window.CC.modal.hide();
    });
  },
  show: function () {
    if (!CC.modal.$modalEle) {
      CC.modal.build();
    }
    CC.modal.$modalEle.addClass('cc-modal-visible');
  },
  hide: function () {
    CC.modal.$modalEle.removeClass('cc-modal-visible');
  },
  map: {
    instance: undefined,
    persistedCoordinates: {
      streetAddress: '',
      latStr: '',
      latNum: 34.065869926528194, // defaults
      lngStr: '',
      lngNum: -118.23910253906251 // defaults
    },
    show: function mapModalShow(callback) {
      if (CC.modal.$modalEle) {
        CC.modal.$modalEle.find('#modal-address').focus(function () {
          $(this).select();
        });
        CC.modal.show();
        return;
      }
      CC.modal.build();

      var viewState = {};
      var persistedValues = window.CC.modal.map.persistedCoordinates;
      var instanceVals = JSON.parse(JSON.stringify(window.CC.modal.map.persistedCoordinates));
      var $inner = CC.modal.$modalEle.find('.cc-mobile-modal--inner');
      var $map = $('<div id="modal-map" class="cc-modal-map"></div>');
      var $instructions = $('<div class="msg-location">Enter an Address then Click or Drag the Map Marker around to set the coordinates (Lat &amp; Long) or just use the map!</div>');
      var $inputWrapper = $('<div class="cc-modal-inputs-wrap">');
      var $inputAddress = $('<input type="text" id="modal-address" class="cc-modal-address cc-styled-input" placeholder="Enter Street Address" autocomplete="off" />');
      var $inputLat = $('<input type="text" disabled class="cc-modal-lat cc-styled-input" placeholder="Latitude" autocomplete="off" />');
      var $inputLng = $('<input type="text" disabled class="cc-modal-lng cc-styled-input" placeholder="Longitude" autocomplete="off" />');
      var $saveBtn = $('<button class="cc-modal-button cc-save-button">SAVE YOUR COORDINATES</button>');
      var $cancelBtn = $('<button class="cc-modal-button cc-cancel-button">CANCEL</button>');

      $inner.append([
        $map, $instructions, $inputWrapper
      ]);
      $inputWrapper.append([
        $instructions, $inputAddress, $inputLat, $inputLng, $saveBtn, $cancelBtn
      ]);

      CC.modal.show();

      var mapEle = document.getElementById('modal-map');
      var addressEle = document.getElementById('modal-address');

      function validateFields() {
        if (!instanceVals.latStr || !instanceVals.lngStr) {
          $inputAddress.addClass('error');
          $inputLat.addClass('error');
          $inputLng.addClass('error');
          return false;
        }
        return true;
      }
      function clearFieldValidation() {
        $inputAddress.removeClass('error');
        $inputLat.removeClass('error');
        $inputLng.removeClass('error');
      }
      function createMapType() {
        var roadAtlasStyles = [{elementType:"geometry",stylers:[{color:"#f5f5f5"}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{elementType:"labels.text.stroke",stylers:[{color:"#f5f5f5"}]},{featureType:"administrative.land_parcel",elementType:"labels.text.fill",stylers:[{color:"#bdbdbd"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"road",elementType:"geometry",stylers:[{color:"#ffffff"}]},{featureType:"road.arterial",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#dadada"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"transit.line",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"transit.station",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#b2d3db"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]}];
        return new google.maps.StyledMapType(
          roadAtlasStyles,
          {}
        );
      }
      function createMarker() {
        var default_coordinates = new google.maps.LatLng(
          instanceVals.latNum,
          instanceVals.lngNum
        );
        return new google.maps.Marker({
          position: default_coordinates,
          map: undefined,
          draggable: true,
          animation: google.maps.Animation.DROP,
          icon: 'https:' + window.theme.mapMarkers.default,
          title: "Your Coordinates"
        });
      }
      function createMap() {
        return new google.maps.Map(mapEle, {
          zoom: 13,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
      }
      function createAutocomplete(inputEle) {
        return new google.maps.places.Autocomplete(inputEle, { types: ['geocode'] });
      }
      function setPersistedValues(newVals) {
        persistedValues = JSON.parse(JSON.stringify(newVals));
        window.CC.modal.map.persistedCoordinates = JSON.parse(JSON.stringify(newVals));
      }
      function setInstanceValues(latNum, lngNum, formatted_address) {
        clearFieldValidation();
        var c = instanceVals;
        if (formatted_address) {
          c.streetAddress = formatted_address;
        }
        c.latNum = latNum;
        c.lngNum = lngNum;
        c.latStr = CC.utils.coordinates.convertTo.string(c.latNum, 'lat');
        c.lngStr = CC.utils.coordinates.convertTo.string(c.lngNum, 'lng');
      }
      function updateInputValuesFromPersistedValues(usePersisted) {
        var c = usePersisted ? window.CC.modal.map.persistedCoordinates : instanceVals;
        $inputLat.val(c.latStr);
        $inputLng.val(c.lngStr);
        $inputAddress.val(c.streetAddress);
      }
      function updateMapPositionFromPersistedValues(marker) {
        var gMaps = window.google.maps;
        var c = instanceVals;
        marker.setPosition(new gMaps.LatLng(c.latNum, c.lngNum));
      }
      function bindMapEvents(map, marker, $latInput, $lngInput, $inputAddress) {
        var gMaps = window.google.maps;
        var gEvent = gMaps.event;
        var listener = gEvent.addListener;
        var isDragging = false;

        listener(marker, 'dragstart', function markerDragStart() {
          isDragging = true;
        });
        listener(marker, 'dragend', function markerDragEnd() {
          isDragging = false;
          gEvent.trigger(marker, 'position_changed');
        });
        listener(marker, 'position_changed', function markerPositionChanged() {
          if(isDragging) { return; }
          var utils = window.CC.utils.coordinates;
          map.setCenter(marker.position);
          if(viewState.cancelling) { return; }
          var latNum = map.getCenter().lat();
          var lngNum = map.getCenter().lng();
          utils.getAddressFromLatLng(latNum, lngNum, function (formatted_address) {
            setInstanceValues(latNum, lngNum, formatted_address);
            updateInputValuesFromPersistedValues();
          });
        });
        listener(map, 'click', function mapClick(ev) {
          var utils = window.CC.utils.coordinates;
          var latNum = ev.latLng.lat();
          var lngNum = ev.latLng.lng();
          marker.setPosition(new gMaps.LatLng(latNum, lngNum));
          utils.getAddressFromLatLng(latNum, lngNum, function (formatted_address) {
            setInstanceValues(latNum, lngNum, formatted_address);
            updateInputValuesFromPersistedValues();
          });
        });
      }
      function bindAutoCompleteEvents(autocomplete, marker) {
        autocomplete.addListener('place_changed', function autocompletePlaceChanged() {
          var place = autocomplete.getPlace();
          if (!place || viewState.cancelling) { return }
          setInstanceValues(
            place.geometry.location.lat(),
            place.geometry.location.lng(),
            place.formatted_address
          );
          updateInputValuesFromPersistedValues();
          updateMapPositionFromPersistedValues(marker)
        });
      }

      var mapType = createMapType();
      var marker = createMarker();
      var map = createMap();
      var autocomplete;

      window.CC.modal.map.instance = {
        map: map, marker: marker
      };

      map.mapTypes.set('usroadatlas', mapType);
      map.setMapTypeId('usroadatlas');
      map.setCenter(marker.position);
      marker.setMap(map);

      bindMapEvents(map, marker);

      autocomplete = createAutocomplete(addressEle);
      window.CC.modal.map.instance.autocomplete = autocomplete;
      bindAutoCompleteEvents(autocomplete, marker);

      $inputAddress.focus(function inputFocus() {
        $(this).select();
      });

      $saveBtn.on('click', function saveBtnClick() {
        setPersistedValues(instanceVals);
        if (validateFields()) {
          CC.modal.hide();
          setPersistedValues(instanceVals);
          callback(persistedValues);
        }
      });
      function cancelMapModal() {
        clearFieldValidation();
        viewState.cancelling = true;
        instanceVals = JSON.parse(JSON.stringify(window.CC.modal.map.persistedCoordinates));
        // this will update vals
        updateMapPositionFromPersistedValues(marker);
        updateInputValuesFromPersistedValues(true);
        instanceVals = JSON.parse(JSON.stringify(window.CC.modal.map.persistedCoordinates));
        viewState.cancelling = false;
        callback(instanceVals);
        CC.modal.hide();
      }
      window.CC.modal.$modalEle.find('.cc-modal-close').on('click', function closeClick() {
        cancelMapModal();
      });
      $cancelBtn.on('click', function cancelBtnClick() {
        cancelMapModal();
      });
    }
  }
};

window.CustomEvent
&& document.body.dispatchEvent
&& document.body.dispatchEvent(new CustomEvent('cc-map.lib-loaded', {}));
window.CC.loaded = true;
